import { Brand } from "../../components/Brand";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Field } from "../../components/ui";
import { requestPasswordReset } from "./api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await requestPasswordReset(email.trim());
    } finally {
      setBusy(false);
      setSent(true);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <Brand className="login-brand" />
        <h1>Mot de passe oublié</h1>
        {sent ? (
          <p className="hint">
            Si un compte existe pour cette adresse, un email de réinitialisation vient d'être
            envoyé.
          </p>
        ) : (
          <>
            <Field
              label="Email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button type="submit" disabled={busy}>
              {busy ? "Envoi…" : "Envoyer le lien"}
            </Button>
          </>
        )}
        <nav className="auth-links">
          <Link to="/login">Retour à la connexion</Link>
        </nav>
      </form>
    </div>
  );
}
